export default __webpack_public_path__ + "static/media/confetti-TL.c1a46db6.svg";